export const doComplete = null
export const extractAbbreviation = null
export const isAbbreviationValid = null
